import React, { useState, useEffect, useRef } from "react";
import { Modal, Header, Image, Input } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {
  postDatasetRequestAccess,
  getOthersDatasets,
  ListOthersSuccess,
} from "../../actions/dataConsoleAction";
import TableRowsLoaderApprovedDataset from "../Pagination/TableRowsLoaderApprovedDataset";
import PaginationOthersDataset from "../Pagination/PaginationOthersDataset";
import "../../styles/Dataset.css";
import Loader from "../../components/Loader";
import MobileOthersDataset from "./MobileOthersDataset";

const OtherDataset = ({ setDatsetCount, showToaster, dataFromChild }) => {
  const dispatch = useDispatch();
  const { loading, responseDataRequestList, error } = useSelector(
    (state) => state.requestDatasetReducer || {}
  );
  const { othersDatasetData } = useSelector(
    (state) => state.getOthersDatasetReducer || {}
  );
  const [open, setOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [datas, setDatas] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const isMounted = useRef(true);
  const [loadingData, setLoadingData] = useState(true);
  const [LoaderFlag, setLoaderFlag] = useState(false);
  const [requestSuccess, setRequestSuccess] = useState(true);
  const [statusChange, setStatusChange] = useState(false);
  const [isLoadings, setIsLoadings] = useState(true);

  const getDataSet = () => {
    try {
      const params = {
        userAccessType: "Anonymous",
      };
      dispatch(getOthersDatasets(params));
      dispatch(ListOthersSuccess());
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };

  useEffect(() => {
    // Simulate fetching data with a timeout
    // Replace this with your actual data fetching logic
    setTimeout(() => {
      setIsLoadings(false);
    }, 1000); // Adjust the timeout duration as needed
  }, []);

  useEffect(() => {
    if (isMounted.current || deleteStatus) {
      getDataSet();
      isMounted.current = false;
    }
  }, [dispatch, deleteStatus]);

  useEffect(() => {
    if (othersDatasetData.length > 0) {
      setLoadingData(false);
      if (dataFromChild) {
        const fitleredData = othersDatasetData.filter((results) => {
          return results.datasetName
            .toString()
            .toLowerCase()
            .includes(dataFromChild);
        });
        if (fitleredData.length > 0) {
          setDatas(fitleredData);
        } else {
          setDatas([]);
        }
      } else {
        setDatas(othersDatasetData);
      }
    } else {
      if (requestSuccess) {
        setDatas(othersDatasetData);
      }
    }
  }, [dataFromChild, othersDatasetData]);

  useEffect(() => {
    if (!statusChange) {
      setIsButtonEnabled(false);
      setDatsetCount(othersDatasetData.length);
      if (othersDatasetData.length > 0) {
        if (requestSuccess) {
          setDatas(othersDatasetData);
        }
        // setLoadingData(false);
      }
    }
  }, [othersDatasetData, statusChange]);

  const columns = [
    { id: "datasetName", label: "Dataset" },
    { id: "files", label: "Documents" },
    { id: "accessUsers", label: "Status" },
  ];

  const columnsSkelton = [
    { id: "datasetName", label: "Dataset name" },
    { id: "files", label: "Documents" },
    { id: "accessUsers", label: "Status" },
    { id: "action", label: "Action" },
  ];

  const handleClose = () => {
    setOpen(false);
    setDatasetExistError("");
    setInputValue("");
    setSpecialChar(true);
  };
  const handleCloseFlag = () => {
    setOpen(false);
    setDatasetExistError("");
    setSpecialChar(true);
  };

  const navigate = useNavigate();
  const otherdataset = async (path) => {
    navigate("/" + path);
  };
  const location = useLocation();

  const updatenewdata = (data) => {
    console.log("data", data);
    setDatas(data);
  };

  const updateRequestSuccess = (flag) => {
    setRequestSuccess(flag);
  };

  const updateLatestDataset = () => {
    getDataSet();
  };

  return (
    <div>
      <div className="mobile-dataset-container">
        <div className="mobile-dataset-header dataset-nav-box">
          <div
            className={
              location.pathname === "/data-sets"
                ? "mobile-dataset-header-left"
                : ""
            }
          >
            <span onClick={() => otherdataset("data-sets")}>
              Approved Dataset
            </span>
          </div>
          <div
            className={
              location.pathname === "/other-datasets"
                ? "mobile-dataset-header-left"
                : ""
            }
          >
            <span onClick={() => otherdataset("other-datasets")}>
              Other Dataset
              {location.pathname === "/other-datasets" && !isLoadings
                ? `(${datas.length})`
                : ""}
            </span>{" "}
            <span></span>
          </div>
        </div>
      </div>
      {loadingData ? (
        <TableRowsLoaderApprovedDataset columns={columnsSkelton} rowsNum={10} />
      ) : datas.length > 0 && !isMounted.current && !isLoadings ? (
        <>
          <div className="mobile-dataset-mobile-box">
            <MobileOthersDataset
              columns={columns}
              data={datas}
              showToaster={showToaster}
              setDeleteStatus={setDeleteStatus}
              loaderFlag={LoaderFlag}
              result={updatenewdata}
              newResult={datas}
              request={updateRequestSuccess}
              statusChange={setStatusChange}
              updateLatestDataset={updateLatestDataset}
            />
          </div>

          <div className="desktop-dataset-container">
            <PaginationOthersDataset
              columns={columns}
              data={datas}
              showToaster={showToaster}
              setDeleteStatus={setDeleteStatus}
              loaderFlag={LoaderFlag}
              result={updatenewdata}
              newResult={datas}
              request={updateRequestSuccess}
              statusChange={setStatusChange}
              updateLatestDataset={updateLatestDataset}
            />
          </div>
        </>
      ) : (
        <>
          <div className="emptyContainer">
            <Image src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No data available </span>
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default OtherDataset;
